import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'reactstrap';
import DOMPurify from 'dompurify';
import ITextTruncate from './interfaces/ITextTruncate';

const DEFAULT_TRUNCATE_LENGTH = 375;

const TextTruncate = ({
  text: t, maxLength = DEFAULT_TRUNCATE_LENGTH, showExpandButton: show = true,
}:ITextTruncate) => {
  const pureText = t ? DOMPurify.sanitize(t) : '';
  const hasLongText = pureText.length > maxLength;
  const showExpandButton = show && hasLongText;

  const [truncate, setTruncate] = useState(hasLongText);
  const [translate] = useTranslation();

  const truncateLabel = truncate
    ? translate('COMPONENTS.CAMPAIGN_HEADER.READ_MORE')
    : translate('COMPONENTS.CAMPAIGN_HEADER.READ_LESS');

  const text = truncate ? `${pureText.substring(0, maxLength)}...` : pureText;

  const textStyle = `mb-3 ${show ? 'd-inline' : 'd-inline-block'}`;

  const toggleTruncate = () => setTruncate((state) => !state);

  return (
    <>
      <div className={textStyle} dangerouslySetInnerHTML={{ __html: text }} />
      {' '}
      {showExpandButton && (
        <Button
          color="link"
          className="p-0 align-baseline fw-normal border-0"
          onClick={toggleTruncate}
        >
          {truncateLabel}
        </Button>
      )}
    </>
  );
};

export default TextTruncate;
